/**
 * Constants for the experience strategy
 */

// Predefined experience level options
export const EXPERIENCE_LEVELS = {
  ENTRY: { label: 'Entry Level (0-2yrs)', range: [0, 2], displayText: '0-2 years of experience' },
  JUNIOR: { label: 'Junior Level (2-5yrs)', range: [2, 5], displayText: '2-5 years of experience' },
  MID: { label: 'Mid Level (5-8yrs)', range: [5, 8], displayText: '5-8 years of experience' },
  SENIOR: { label: 'Senior Level (8+yrs)', range: [8, 30], displayText: '8+ years of experience' },
  CUSTOM: { label: 'Custom Range', range: null, displayText: 'Custom range' }
};
